<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <el-button no="1" type="primary" :disabled="isEdit" @click="autoAllocateCargoHandler">{{ $t('SeaExport.AutoDistribution') }}</el-button>
          <el-button no="2" type="primary" :disabled="isEdit" @click="allocateCargoHandler">{{ $t('SeaExport.ManualDistribution') }}</el-button>
          <el-button no="3" type="primary" :disabled="!btUnlockEnabled" @click="removeRelationHandler">{{ $t('SeaExport.Unlock2') }}</el-button>
          <el-button v-show="!isEdit" no="4" type="primary" :disabled="(!!job.uuid && !readonly) || otherCheck" @click="addWarehouseInHandler">{{ $t('SeaExport.InputWarehouseData') }}</el-button>
          <el-button v-show="!isEdit" no="5" type="primary" :disabled="(!!job.uuid && !readonly) || otherCheck" @click="editWarehouseInHandler">{{ $t('SeaExport.EditWarehouseData') }}</el-button>
          <el-button v-show="!isEdit" no="6" type="primary" :disabled="(!!job.uuid && !readonly) || otherCheck" @click="deleteWarehouseData">{{ $t('SeaExport.DeleteWarehouseData') }}</el-button>
          <el-button no="goodsArrived" type="primary" :disabled="!!job.uuid && !readonly" @click="goodsArrivedHandler">{{ $t('CargoMsg.Cargo_GoodsArrived') }}</el-button>
          <el-button no="outboundOrder" type="primary" :disabled="(!!job.uuid && !editOther) || Boolean(job.outboundStatus)" @click="outboundOrderHandler">{{ $t('CargoMsg.Cargo_OutboundOrder') }}</el-button>
          <el-button no="cancelOutboundOrder" type="primary" :disabled="(!!job.uuid && !editOther) || Boolean(!job.outboundStatus)" @click="cancelOutboundOrderHandler">{{ $t('CargoMsg.Cargo_CancelOutboundOrder') }}</el-button>
        </cargo-button-group-slider>
        <p class="preserve-space" style="flex-grow: 1;text-align: right;margin-top: 0px;">
          <span style="color:red">{{ job.outboundStatus ? $t('CargoMsg.Cargo_OutboundInstructionIssued') : '' }}</span>
          {{ $t('SeaExport.itemCount') }}&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;{{ total.itemCount }}&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;{{ total.actualItemCount }}&nbsp;&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.Weight') }}&nbsp;&nbsp;&nbsp;&nbsp;KGS:&nbsp;&nbsp;&nbsp;&nbsp;{{ total.weight }}&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;{{ total.actualWeight }}&nbsp;&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.Cubage') }}&nbsp;&nbsp;&nbsp;&nbsp;CBM:&nbsp;&nbsp;&nbsp;&nbsp;{{ total.cubage }}&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;{{ total.actualCubage }}
        </p>
      </div>
    </div>
    <div style="height: 100%">
      <cargo-ag-grid
        config-module="190004"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 查询仓库记录弹窗 -->
    <warehouse-record-dialog :visible.sync="warehouseRecordDialog.visible" :lob="job.lob" @selectWarehouseHandler="selectWarehouseHandler" />
    <!-- 仓储明细 -->
    <warehouse-in-detail-dialog
      :visible.sync="warehouseInDetailDialog.visible"
      :action="action"
      :context="context"
      :job="warehouseInDetailDialog.job"
      :warehouse="warehouseInDetailDialog.warehouse"
      :title="warehouseInDetailDialog.title"
      :open-imperial="openImperial"
      @commit="commit"
      @winClose="winClose"
    />
    <!-- 查询进仓照片 -->
    <picture-view-window
      :visible.sync="pictureView.visible"
      :job="job"
      :model="pictureView.model"
      :title="pictureView.title"
      :file-name="pictureView.fileName"
      :type="pictureView.type"
    />
  </div>
</template>

<script>

import {
  warehouseInList,
  warehouseInUnLock,
  autoAllocateCargo,
  delWarehouseInForAe,
  batchUploadPhotoData, batchWarehuseIn
} from '@/api/seaExport/warehouseIn'
import { cacheName, cache } from '@/utils/cacheManager'
import warehouseRecordDialog from '@/components/Cargo/Job/warehouseSearchDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import warehouseInDetailDialog from './components/warehouseInDetailDialog'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { Job } from '@/class/model/booking/Job'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import photo_camera from '@/assets/photo_camera-32.png'
import { DocumentManage } from '@/utils/commonUtil'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import { outboundOrderFunc, updateWarehouseInFunc } from '@/api/warehouseIn/warehouseIn'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { IMPERIAL_1 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabWarehouse',
  components: { warehouseRecordDialog, warehouseInDetailDialog, CargoButtonGroupSlider, pictureViewWindow },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        onRowClicked: this.onRowClicked,
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: '',
          width: 220,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            innerRenderer: (params) => {
              return this.firstColumnLabelFun(params.data.uuid)
            }
          }
        }
      },
      rowData: [],
      gridApi: null,
      warehouseRecordDialog: {
        visible: false
      },
      currentUser: {},
      job: { lob: '' },
      selectedWarehousIn: null,
      refreshDocData: false,
      stayWarehousingNew: false, // 是否前置仓
      refreshDocActualData: false,
      warehouseInDetailDialog: {
        visible: false,
        job: {},
        warehouse: {},
        title: ''
      },
      openImperial: false,
      selectedRowIndex: -1,
      documentManage: new DocumentManage(),
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: ''
      },
      otherCheck: false,
      total: {
        itemCount: 0,
        actualItemCount: 0,
        weight: 0,
        actualWeight: 0,
        cubage: 0,
        actualCubage: 0
      },
      aEcWeightCeil: 0
    }
  },
  computed: {
    editOther() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    editByWarehouseStatus() { // 完全入库-不能编辑
      return this.job && this.job.warehouseStatus === WarehouseInState.FULLY_STORED.code
    },
    readonly() {
      if (this.editByWarehouseStatus) return false
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (this.editByWarehouseStatus) return true
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    btUnlockEnabled() {
      if (this.editByWarehouseStatus) return false
      return this.action === 'look' && this.rowData && this.rowData.length > 0
    },
    columnDefs() {
      const list = [
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 120,
          cellRenderer: (params) => {
            return params.data ? this.quantityLabFunc(params.data.uuid) : 0
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 120,
          cellRenderer: (params) => {
            return params.data ? this.weightLabFunc(params.data.uuid, false) : 0
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 120,
          cellRenderer: (params) => {
            return params.data ? this.cubageLabelFun(params.data.uuid, false) : 0
          }
        },
        {
          headerName: this.$t('SeaExport.Size'),
          field: 'dimension',
          width: 120,
          cellRenderer: (params) => {
            if (!params.value) {
              return ''
            }
            return [...new Set(params.value.split(';'))].join(';')
          }
        },
        {
          headerName: this.$t('SeaExport.WhetherOrNotBroken'),
          field: 'broken',
          width: 120,
          cellRenderer: (params) => {
            return this.isBrokenLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BrokenDesc'),
          field: 'brokenDes',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DocumentsWithCargo'),
          field: 'receiveDc',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('SeaExport.PackageType'), field: 'packing', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', params.value, 'chineseName')
          } },
        {
          headerName: this.$t('SeaExport.BangPic'),
          field: 'uuid',
          cellRenderer: params => {
            const obj = this.rowData.find(x => x.uuid === params.data.uuid)
            if (obj.parent) {
              if (params.data.frontEndWarehouse === '1' && params.data.hasFile !== 1) {
                return ''
              }
              const methodPath = this.documentManage.getPath('showAttachHandler')
              return `<span><img src="${photo_camera}" height="16" width="16" style="vertical-align: sub;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
            return ''
          },
          excelRenderer: params => {
            return ''
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.WareHouseName'),
          field: 'referenceNo',
          width: 120,
          cellRenderer: (params) => {
            const name = params.data ? this.referenceNoLabFun(params.data.uuid) : ''
            if (name) {
              return name
            }
            return params.data.warehouse
          }
        },
        {
          headerName: this.$t('SeaExport.WareHouseMarks'),
          field: 'marks',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedWarehousingTime'),
          field: 'estimatedWarehousingTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedDeliveryTime'),
          field: 'estimatedDeliveryTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualWarehousingTime'),
          field: 'warehouseInDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualDeliveryTime'),
          field: 'warehouseOutDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ReceiptNo'),
          field: 'receiptNo',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'truckNo',
          width: 120,
          hide: true
        }
      ]
      if (this.stayWarehousingNew) {
        list.push({
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'state',
          field: 'state',
          width: 150,
          cellRenderer: (params) => {
            if (params.data && !params.data.parent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE_LIST, 'code', Number(params.value), 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarehouseInState'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data && !params.data.parent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          },
          hide: true
        })
      } else {
        list.push({
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 150,
          cellRenderer: (params) => {
            if (params.data && !params.data.parent) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          },
          hide: true
        })
      }
      if (this.openImperial) {
        list.push({
          headerName: this.$t('SeaExport.Weight') + 'LB',
          field: 'weightImperial',
          width: 120,
          cellRenderer: (params) => {
            return params.data ? this.weightLabFunc(params.data.uuid, true) : 0
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage') + 'CFT',
          field: 'cubAgeImperial',
          width: 120,
          cellRenderer: (params) => {
            return params.data ? this.cubageLabelFun(params.data.uuid, true) : 0
          }
        },
        {
          headerName: this.$t('SeaExport.Size') + '(' + this.$t('CargoMsg.Cargo_Inch') + ')',
          field: 'dimensionImperial',
          width: 120,
          cellRenderer: (params) => {
            if (!params.value) {
              return ''
            }
            return [...new Set(params.value.split(';'))].join(';')
          }
        })
      }
      return list
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showAttachHandler', function() {
      context.showAttachHandler()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        await cache.load(cacheName.USER, cacheName.CONFIG)
        this.currentUser = cache.user
        this.job = row
        this.refreshDocData = parseInt(cache.config.get('refreshDocData')) === 1
        this.stayWarehousingNew = parseInt(cache.config.get('StayWarehousingNew')) === 1
        this.refreshDocActualData = parseInt(cache.config.get('refreshDocActualData')) === 1 || cache.config.get('SynchronizeWarehouseDataToJob').split(',').includes(this.job.lob)
        this.aEcWeightCeil = parseInt(cache.config.get('AEcWeightCeil'))
        if (!this.job.warehouseIn || this.job.warehouseIn.length === 0) {
          await new Job(this.job).getWarehouseIn()
        }
        // 英制单位开启时 ，设置英制显示列
        await JobUtils.initImperialData(IMPERIAL_1.code).then(r => {
          this.openImperial = r
        })
        this.loadWarehouseIn()
        this.checkOtherEdit()
      }
    },
    async checkOtherEdit() {
      this.otherCheck = false
      // 当选择了前置仓 ，且不是代理库时，不可编辑
      if (this.job.frontEndWarehouseOperation) {
        const warehouseOperations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
          .filter(data => data.uuid === this.job.frontEndWarehouseOperation)
        if (warehouseOperations && warehouseOperations.length > 0) {
          this.otherCheck = warehouseOperations[0].warehouseType !== 0
        }
      }
    },
    async loadWarehouseIn() {
      await warehouseInList(this.job.uuid).then(res => {
        this.rowData = [...res.data]
      })
      this.summary()
    },
    summary() {
      this.total.actualItemCount = this.job.quantityActual
      this.total.actualWeight = this.job.weightActual
      this.total.actualCubage = this.job.cubageActual
      this.total.itemCount = 0
      this.total.weight = 0
      this.total.cubage = 0
      for (const item of this.rowData) {
        if (item && !item.parent) {
          this.total.itemCount += item.quantity || 0
          this.total.weight += item.weight || 0
          this.total.cubage += item.cubage || 0
        }
      }
      this.total.itemCount = NumberUtils.formatNumber(this.total.itemCount)
      this.total.weight = NumberUtils.formatNumber(this.total.weight, 3)
      this.total.cubage = NumberUtils.formatNumber(this.total.cubage, 3)
      this.total.actualWeight = Number(this.total.actualWeight).toFixed(3)
      this.total.actualCubage = Number(this.total.actualCubage).toFixed(3)
    },
    addWarehouseInHandler() {
      const warehouse = new WarehouseIn().fillDefaultValue().getData()
      warehouse.warehouseUuid = null
      warehouse.lob = this.job.lob
      warehouse.warehouseInDate = new Date()
      warehouse.branchId = this.$store.getters.currentOfficeId
      warehouse.warehouseOp = this.$store.getters.userId
      this.warehouseInDetailDialog.job = this.job
      this.warehouseInDetailDialog.warehouse = warehouse
      this.warehouseInDetailDialog.visible = true
      this.warehouseInDetailDialog.title = this.$t('SeaExport.InputWarehouseData')
    },
    editWarehouseInHandler() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('queryJob.PleaseSelectWarehousingData'))
        return
      }
      this.warehouseInDetailDialog.title = this.$t('SeaExport.EditWarehouseData')
      this.warehouseInDetailDialog.job = this.job
      const path = this.selectedRow.path
      const pathArray = path.split(',')
      let warehouseEntity = {}
      if (pathArray.length === 1) { // 列表显示分为两级，等于1为父级
        warehouseEntity = this.selectedRow
      } else {
        const parentUuid = pathArray[0]
        let warehouse = null
        for (const item of this.rowData) {
          if (item.path && item.path === parentUuid) {
            warehouse = item
            break
          }
        }
        warehouseEntity = warehouse
      }
      // warehouseEntity 中字段不全，会导致更新的时候丢失
      if (warehouseEntity && warehouseEntity.uuid && this.job.warehouseIn && this.job.warehouseIn.length > 0) {
        for (const entity of this.job.warehouseIn) {
          if (entity.uuid === warehouseEntity.uuid) {
            warehouseEntity = entity
            break
          }
        }
      }
      if (warehouseEntity) {
        this.warehouseInDetailDialog.warehouse = warehouseEntity
        this.warehouseInDetailDialog.visible = true
      }
    },
    deleteWarehouseData() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('AirExport.PleaseSelectWarehouseEntryData'))
        return
      }
      if (this.selectedRow.uuid) {
        this.$confirm(this.$t('queryJob.AreToDeleteThisData'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          type: 'info'
        }).then(() => {
          delWarehouseInForAe({ warehouseInUuid: this.selectedRow.uuid }).then(async res => {
            if (res.data) { // 调用后端方法，修改job属性，返回后更新对应的修改字段
              this.$message.success('删除成功！')
              await this.winClose()
              await this.loadWarehouseIn()
            }
          })
        }).catch(() => false)
      }
      this.summary()
    },
    goodsArrivedHandler() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('AirExport.PleaseSelectWarehouseEntryData'))
        return
      }
      updateWarehouseInFunc({ uuid: this.selectedRow.uuid }).then(async res => {
        await this.winClose()
      })
    },
    outboundOrderHandler() {
      if (!this.rowData || this.rowData.length === 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_NotInWarehouse'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.doOutboundOrderHandler(1)
        })
      } else {
        this.doOutboundOrderHandler(1)
      }
    },
    cancelOutboundOrderHandler() {
      if (!this.rowData || this.rowData.length === 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_NotInWarehouse2'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.doOutboundOrderHandler(0)
        })
      } else {
        this.doOutboundOrderHandler(0)
      }
    },
    async doOutboundOrderHandler(status) {
      const data = {
        jobUuid: this.job.uuid,
        outboundStatus: status
      }
      outboundOrderFunc(data).then(async res => {
        if (res.data) {
          // 取消时，存在已经出库数据
          if (res.data === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyOutbound'))
          } else {
            if (status === 1) {
              this.$message.success(this.$t('CargoMsg.Cargo_WarehouseTip2'))
            } else {
              this.$message.success(this.$t('CargoMsg.Cargo_WarehouseTip3'))
            }
          }
        }
        await this.winClose()
      })
    },
    firstColumnLabelFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        return obj.warehouseNo + ' ' + ColumnUtils.dateTimeLabelFunc(obj.warehouseInDate)
      } else {
        return ColumnUtils.packingCodeLabelFun(obj.packing)
      }
    },
    quantityLabFunc(uuid) {
      const obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let quantity = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          quantity = quantity + item.quantity
        }
        return NumberUtils.formatNumber(quantity)
      } else {
        return obj.quantity
      }
    },
    weightLabFunc(uuid, imperial) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let weight = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          if (imperial) {
            weight = weight + item.weightImperial
          } else {
            weight = weight + item.weight
          }
        }
        return NumberUtils.formatNumber(weight, 3)
      } else {
        if (imperial) {
          return obj.weightImperial
        } else {
          return obj.weight
        }
      }
    },
    cubageLabelFun(uuid, imperial) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let cubage = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          if (imperial) {
            cubage = cubage + item.cubAgeImperial
          } else {
            cubage = cubage + item.cubage
          }
        }
        return NumberUtils.formatNumber(cubage, 3)
      } else {
        if (imperial) {
          return obj.cubAgeImperial
        } else {
          return obj.cubage
        }
      }
    },
    isBrokenLabelFunc(broken) {
      if (broken == null) return ''
      return broken ? '√' : ''
    },
    referenceNoLabFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      const referenceNo = obj.referenceNo
      if (!StrUtils.isEmpty(referenceNo)) {
        if (referenceNo.indexOf('EYGX') > -1) {
          return this.$t('SeaExport.EnyuanGaoxiangku')
        } else if (referenceNo.indexOf('EYYY') > -1) {
          return this.$t('SeaExport.EnyuanYangyuanKu')
        } else if (referenceNo.indexOf('EYHQ') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        } else if (referenceNo.indexOf('EYLD') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        }
      }
    },
    onRowClicked(event) {
      this.selectedWarehousIn = event.data
    },
    autoAllocateCargoHandler() {
      const loading = getLoading4Cxt(this)
      autoAllocateCargo(this.job.uuid).then(async res => {
        await this.loadWarehouseIn()
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this.$t('Message.DistributeFailedNoFoundRelatedStorageRecord'))
        } else {
          new AirExportJob(this.job).loadJobRelated({ 'job': true }).then()
          this.$message.success(this.$t('Message.DistributedSuccessfully'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    allocateCargoHandler() {
      this.warehouseRecordDialog.visible = true
    },
    removeRelationHandler() {
      if (this.selectedWarehousIn === null) {
        return
      }
      this.$confirm(this.$t('Message.SureYouWantToCancelTheBindingToTheStorageData'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          const uuid = this.selectedWarehousIn.uuid
          // 更新 warehouseIn 表上的 jobUuid 为空
          await warehouseInUnLock(uuid)
          // 重新加载列表
          await this.loadWarehouseIn()
          // 是否更新实际件毛体
          if (this.refreshDocActualData) {
            await this.refreshWarehouseInQWC()
          }
        } finally {
          this.loadList()
        }
      }).catch(() => {
      })
    },
    async refreshWarehouseInQWC(selectedWarehouseList = null) {
      if (this.job.lob !== 'SE') {
        let totalQuantity = 0
        let totalWeight = 0
        let totalCubage = 0
        const isAe = this.job.lob === 'AE'
        for (const warehouse of this.rowData) {
          if (!warehouse.parent) {
            totalQuantity += warehouse.quantity || 0
            totalCubage += warehouse.cubage || 0
            if (isAe && warehouse.sealCargo) {
              totalWeight += warehouse.sealWeight || 0
            } else {
              totalWeight += warehouse.weight || 0
            }
          }
        }
        this.job.quantityActual = totalQuantity
        this.job.weightActual = totalWeight
        this.job.cubageActual = totalCubage
        if (isAe) {
          if (this.refreshDocActualData) {
            this.job.cWeight = JobUtils.calcChargeWeight(this.job.weightActual, this.job.cubageActual, true, this.aEcWeightCeil)
          }
          if (selectedWarehouseList && selectedWarehouseList.length > 0) {
            this.job.temperatureRequirement = selectedWarehouseList[0]?.temperatureRequirement
          }
        }
        const data = {}
        for (const key in this.job) {
          if (typeof this.job[key] === 'object') {
            continue
          }
          data[key] = this.job[key]
        }
        if (isAe) {
          await AirExportJob.updateQWCActual(data)
        } else {
          await Job.updateQWCActual(data)
        }
      }
    },
    async selectWarehouseHandler(warehouseList) {
      const loading = getLoading4Cxt()
      try {
        const photoList = []
        for (const warehouse of warehouseList) {
          // 更新 wareHouseIn 上的信息
          warehouse.jobUuid = this.job.uuid
          if (StrUtils.isEmpty(warehouse.lob)) {
            warehouse.lob = this.job.lob
          }
          if (warehouse.branchId === 0) {
            warehouse.branchId = this.job.opOffice
          }
          delete warehouse.warehouseInDetail
          delete warehouse.business_Document
          photoList.push({ jobUuid: this.job.uuid, warehouseInUuid: warehouse.uuid })
        }
        await batchWarehuseIn(warehouseList)
        await batchUploadPhotoData(photoList)
        // 重新加载
        await this.loadWarehouseIn()
        // 更新job 上的信息
        await this.refreshWarehouseInQWC(warehouseList)
        this.warehouseRecordDialog.visible = false
      } catch (e) {
        console.log('error', e)
      } finally {
        loading.close()
      }
    },
    async getSubmitData() {
      return {
        warehouseIn: this.rowData,
        job: { ...this.job }
      }
    },
    // 仓库明细弹窗确认按钮回调函数
    commit() {
      this.loadWarehouseIn()
      this.job.airCargoDoc = ''
      this.job.warehouseIn = ''
      new AirExportJob(this.job).loadJobRelated({ 'airCargoDoc': true, 'warehouseIn': true })
    },
    // 仓库明细弹窗关闭按钮回调函数
    async winClose() {
      this.warehouseInDetailDialog.visible = false
      let jobModel = null
      if (this.job.lob === 'AE') {
        jobModel = new AirExportJob(this.job)
      } else {
        jobModel = new Job(this.job)
      }
      this.context.loading = true
      const loading = getLoading()
      await jobModel.loadJobRelated({
        job: true,
        warehouseIn: true,
        warehouseInfo: true,
        airCargoDoc: this.job.lob === 'AE'
      })
      this.context.loading = false
      loading.close()
      this.loadWarehouseIn()
    },
    // 显示进仓图片
    showAttachHandler(e) {
      if (!this.selectedRow) {
        this.$message.warning('请选择一条数据！')
        return
      }
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = this.selectedRow
      this.pictureView.fileName = this.selectedRow.warehouseNo + '.zip'
      this.pictureView.job = this.job
      this.pictureView.type = 'WarehouseIn'
      this.pictureView.visible = true
    }
  }
}
</script>

<style>
.preserve-space {
  white-space: pre;
}
</style>
